import { createElement } from "react";
import React from "react";
import { Shopfoo_Client_Pages_Shared_Env_IFullContext__IFullContext_get_Translations } from "./Shared.js";
import { useEffectOnce } from "../fable_modules/Feliz.2.9.0/Internal.fs.js";
import { AppTranslations__get_Home, TranslationPages_Home__get_Page, TranslationPages_Home__ErrorNotFound_Z721C83C5, AppTranslations__get_IsEmpty } from "../Shopfoo.Shared/Translations.js";
import { Page, Router_navigatePage } from "../Routing.js";
import { createObj } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { Helpers_combineClasses } from "../fable_modules/Feliz.DaisyUI.5.0.0/DaisyUI.fs.js";
import { reactApi } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { ofArray } from "../fable_modules/fable-library-js.4.24.0/List.js";

export function NotFoundView(notFoundViewInputProps) {
    let elems_1, elems;
    const url = notFoundViewInputProps.url;
    const env = notFoundViewInputProps.env;
    const translations = Shopfoo_Client_Pages_Shared_Env_IFullContext__IFullContext_get_Translations(env);
    useEffectOnce(() => {
        if (AppTranslations__get_IsEmpty(translations)) {
            Router_navigatePage(new Page(3, []));
        }
    });
    return createElement("div", createObj(Helpers_combineClasses("alert", ofArray([["className", "alert-error"], ["key", "product-not-found"], (elems_1 = [createElement("span", {
        key: "pnf-icon",
        children: "⛓️‍💥",
        className: "text-lg mr-1",
    }), createElement("span", createObj(ofArray([["key", "pnf-content"], (elems = [createElement("span", {
        key: "pnf-text",
        children: TranslationPages_Home__ErrorNotFound_Z721C83C5(AppTranslations__get_Home(translations), TranslationPages_Home__get_Page(AppTranslations__get_Home(translations))),
    }), createElement("code", {
        key: "pnf-sku",
        children: ` ${url} `,
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))));
}

